import { useRouter } from 'next/router';
import React from 'react';

import { Search } from '@sravni/react-icons';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { MenuItem } from '../FormatsMenu/components/Item';

import { SearchInput } from './components/SearchInput';
import styles from './search-block.module.scss';

interface IProps {
  toggleOverlay?: (value: 'on' | 'off') => void;
  topBlock?: boolean;
  topBlockActive?: boolean;
}

export const SearchBlock = ({ topBlock, toggleOverlay, topBlockActive }: IProps) => {
  const { asPath } = useRouter();
  const isMobile = useIsMobile();

  const [focused, setFocused] = useBoolean(false);

  const isActive = asPath.includes('/search');

  const handleFocusOff = () => setFocused.off();

  const handleOverlayClick = () => {
    if (toggleOverlay) toggleOverlay('on');
  };

  if (!isMobile && topBlock) return null;

  if ((isMobile && topBlock) || (!isActive && focused)) {
    return (
      <div className={styles.topWrapper} onClick={handleOverlayClick}>
        <SearchInput
          handleFocusOff={handleFocusOff}
          topBlock={topBlock}
          menuBlock={!topBlock}
          topBlockActive={topBlockActive}
          toggleOverlay={toggleOverlay}
        />
      </div>
    );
  }

  const item = {
    name: 'Поиск',
    icon: <Search />,
    link: null,
    isActive,
    isVisible: true,
  };

  return <MenuItem item={item} onClick={setFocused.on} />;
};
